import React, { Component } from 'react';
import '../styles/css/app.css';
import moment from 'moment'
import parse from 'html-react-parser';
import StackGrid from "react-stack-grid";

class BlogCards extends Component {
  constructor(props){
    super(props);
    this.state ={ 
      // isLoadingComplete: false,
      // blogPosts: [],
      filterPosts: false,
    }
  }
    componentDidMount() {
      if (this.props.match.params.tag) {
        this.setState({filterPosts: true})
      }


    console.log(this.props.apiData)
  }


  render() {  

    let id = this.props.match.params.tag
    console.log(id ? ("true", id) : "false")

    const filterBlogCards = this.props.apiData.filter(post => id === post.category.toLowerCase())
    console.log(filterBlogCards, "filte")
    let filteredCards = filterBlogCards.map(post => 
    
      <div key={post._id} className="blog-cards-container">
        <img style={{width: '315px'}} alt="" src={post.image}/>
        <div className="blog-cards">
          <a className="title" href={`/blog/${post._id}`} >{post.title}</a>
          <div>{moment(post.created_at).format("MMMM D, YYYY")}</div>
          <br/>
          <article> {parse(post.body)}</article>
          <i>{post.category}</i>
          <br/>
        </div>
        <footer> 
          <a className="fa fa-facebook"></a>
          <a className="fa fa-twitter"></a>
          <a className="fa fa-google-plus"></a> 
        </footer>

      </div>)

    let createCards = this.props.apiData.map(post => 
    
          <div key={post._id} className="blog-cards-container">
            <img style={{width: '315px'}} alt="" src={post.image}/>
            <div className="blog-cards">
              <a className="title" href={`/blog/${post._id}`} >{post.title}</a>
              <div>{moment(post.created_at).format("MMMM D, YYYY")}</div>
              <br/>
              <article> {parse(post.body)}</article>
              <i>{post.category}</i>
              <br/>
            </div>
            <footer> 
              <a className="fa fa-facebook"></a>
              <a className="fa fa-twitter"></a>
              <a className="fa fa-google-plus"></a> 
            </footer>

          </div>
        )
        let setCards = this.state.filterPosts ? filteredCards : createCards
    return (
      <div className="App">
      <StackGrid
      columnWidth={325}
      >
      {setCards} 
      </StackGrid>
    </div>
    );
  }
}

export default BlogCards;